import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A tiny ES6 fetch() wrapper that makes your life easier",
  "description": "",
  "published": "2016-11-02T00:00:00.000Z",
  "redirect_from": ["/blog/a-tiny-es6-fetch-wrapper/swizec/7177"],
  "categories": "Front End, react, Technical",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`After `}<a parentName="p" {...{
        "href": "link"
      }}>{`yesterday's shenanigans`}</a>{` with ES6 fetch(), I made a tiny library called `}<a parentName="p" {...{
        "href": "https://github.com/Swizec/better-fetch"
      }}>{`better-fetch`}</a>{` which makes your life easier. Or at least it makes `}<em parentName="p">{`my`}</em>{` life easier.`}</p>
    <p>{`Without changing the API, better-fetch `}<strong parentName="p">{`automatically includes cookies`}</strong>{`, which would have saved me a very frustrating amount of time yesterday, lets you `}<strong parentName="p">{`add default headers`}</strong>{`, and you can `}<strong parentName="p">{`pass request body as a plain JS object`}</strong>{`. None of that `}<inlineCode parentName="p">{`FormData`}</inlineCode>{` nonsense.`}</p>
    <p><inlineCode parentName="p">{`better-fetch`}</inlineCode>{` works the same as `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{`, but is less cumbersome to use.`}</p>
    <h2 {...{
      "id": "in-practice-better-fetch-looks-like-this"
    }}>{`In practice, better-fetch looks like this:`}</h2>
    <p>{`You install with npm. Or whatever you use to install packages from npmjs.org. Yarn maybe?`}</p>
    <pre><code parentName="pre" {...{}}>{`$ npm install --save better-fetch
`}</code></pre>
    <p>{`Then you set up headers that every one of your `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{` calls needs. My backend requires an `}<inlineCode parentName="p">{`Authorization`}</inlineCode>{` and an `}<inlineCode parentName="p">{`Accept`}</inlineCode>{` header from all calls.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// top of project
// src/index.js

import fetch from "better-fetch";

fetch.setDefaultHeaders({
  Authorization: \`Token token=\${GlobalTokenValue}\`,
  Accept: "application/json.v2",
});

// ^ this is optional and depends on your use-case ^
`}</code></pre>
    <p>{`You can then use `}<inlineCode parentName="p">{`better-fetch`}</inlineCode>{` anywhere in your code as you normally would with `}<inlineCode parentName="p">{`fetch()`}</inlineCode>{`. The API feels the same and promises to work just like you'd expect.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// any file
import fetch from "better-fetch";

fetch("/api/some/thing")
  .then((response) => response.json())
  .then((json) => {
    // do stuff
  });
`}</code></pre>
    <p>{`This code fetches JSON document with a `}<inlineCode parentName="p">{`GET`}</inlineCode>{` request to the `}<inlineCode parentName="p">{`/api/some/thing`}</inlineCode>{` URL. Any default headers are set in the request and cookies are sent as well.`}</p>
    <p>{`POST-ing is also made less cumbersome:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`// any file
import fetch from "better-fetch";

const data = {
  key: "value",
  key2: "value2",
};

fetch("/api/save_response", { method: "POST", body: data })
  .then((response) => response.json())
  .then((json) => {
    console.log(json);
  });
`}</code></pre>
    <p>{`A dictionary `}<inlineCode parentName="p">{`body`}</inlineCode>{` is automatically transformed into a `}<inlineCode parentName="p">{`FormData`}</inlineCode>{` object, and strings and FormData objects are let through. This gives you flexibility to work with any API backend, but it still makes your life easier.`}</p>
    <p>{`Similarly, you can specify headers as either a `}<inlineCode parentName="p">{`Headers`}</inlineCode>{` object or a dictionary – better-fetch has you covered.`}</p>
    <p>{`Happy hacking ?`}</p>
    <p>{`PS: I know a bunch of `}<a parentName="p" {...{
        "href": "https://www.npmjs.com/search?q=fetch"
      }}>{`fetch wrappers`}</a>{` exist already. They all make significant changes to the API, and I wanted to avoid that.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      